export class PrincipalService {
    constructor() {
      this._identity = null;
      this._authenticated = false;
    }
  
    isIdentityResolved() {
      return !!this._identity;
    }
  
    isAuthenticated() {
      return this._authenticated;
    }
  
    /**
     * Check if the current identity belongs to the specified role
     *
     * @param {string} role The role to be verified
     */
    isInRole(role) {
      if (!this.isAuthenticated() || !this.isIdentityResolved() || !this._identity.roles) {
        return false;
      }
  
      return this._identity.roles.indexOf(role) >= 0;
    }
  
    /**
     * Check if the current identity belongs to any of the roles
     *
     * @param {string[]} roles The roles to be verified
     */
    isInAnyRole(roles) {
      if (!this.isAuthenticated() || !this.isIdentityResolved() || !this._identity.roles) {
        return false;
      }
  
      return roles.some(role => this.isInRole(role));
    }
  
    authenticate(identity) {
      this._identity = identity;
      this._authenticated = !!identity;
    }
  
    async identity(force) {
      if (force) {
        this._identity = null;
      }
  
      if (this._identity) {
        return this._identity;
      }
  
      throw new Error('no identity');
    }
  }
  